import React, { useState, useEffect, useCallback,useRef } from "react";
import { connect } from "react-redux";
import axios from "axios";
import data from "../../../../assets/apiRoutes.json";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import {
  Column,
  DataGrid,
  GroupPanel,
  Grouping,
  FilterRow,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  LoadPanel,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  StateStoring,
  Toolbar,
  Item
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
const InventorySerialNumberPopup = (props) => {
  const dataGrid = useRef(null);
  const [popupState, setPopUpState] = useState(props.visibility);
  const [serialNumberData, setSerialNumberData] = useState([]);
  const [inventoryItemSerialNumberObj, setInventoryItemSerialNumberObj] =
    useState({
      lotCode: "",
      itemCode: "",
      itemRowid: props.itemObj.itemRowid,
      lotRowid: props.itemObj.lotRowid,
      subLotRowid: props.itemObj.subLotRowid
    });
  var accessToken = props.oidc.user.access_token;
  const columns = [
    "ItemCode",
    "Description-1",
    "Description-2",
    "Status",
    "Class",
    "SubClass",
  ];
  const dataItmGrid = [
    {
      ItemCode: props.itemObj.itemCode,
      "Description-1": props.itemObj.itemDescription1,
      "Description-2": props.itemObj.itemDescription2,
      Status: props.itemObj.itemStatus,
      Class: props.itemObj.classCode,
      SubClass: props.itemObj.subClassCode,
    },
  ];

  const hideInfo = () => {
    setPopUpState(false);
    props.parentCallback(false);
  };

  useEffect(() => {
    loadInventorySerialNumberData();
  }, []);
  const loadInventorySerialNumberData = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Serialnumber.GetSerialNumberByItemId}`,
        inventoryItemSerialNumberObj,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        setSerialNumberData(res.data);
      });
  };

  const gridKey = "b33fafb2-e98c-442c-8c78-9db1264f40e5";
  const [currentLayout, setCurrentLayout] = useState("Default");
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);



  return (
    <div>
      <Popup
        visible={popupState}
        onHiding={hideInfo}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        showTitle={true}
        closeOnOutsideClick={true}
        title="Serial number"
        container="#root"
        className="custom-popup"
      >
          {/* Item Grid */}
          <div className="row">
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
              ref={dataGrid}
              dataSource={dataItmGrid}
              defaultColumns={columns}
              showBorders={true}
            />
          </div>
          {/* Serial Number Grid */}
          <div className="row">
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
              noDataText={serialNumberData.length > 0 ? "" : "No Data"}
              dataSource={serialNumberData}
              showBorders={true}
              className="popupGrid-height"
              hoverStateEnabled={true}
              allowColumnResizing={true}
              allowColumnReordering={true}
            >
              <Export enabled={true} allowExportSelectedData={true} text="Export" />
              <ColumnHeaderFilter />
              <Sorting visible={true} mode="multiple" />
              <LoadPanel enabled={true} />
              <Paging defaultPageSize={10} />
              <Pager
                visible={true}
                showPageSizeSelector={true}
                allowedPageSizes={[5, 10, 20, "all"]}
                showNavigationButtons={true}
              />
              <FilterRow visible={true} />
              <FilterPanel visible={true} />
              <GroupPanel visible={true} />
              <Grouping autoExpandAll={false} />
              <ColumnChooser enabled={true} />
              <StateStoring
                enabled={true}
                type="custom"
                customLoad={loadState}
                storageKey={gridKey}
                customSave={saveState}
              />
              <Column dataField="serialNumberCode" caption={Localization.formatMessage('WMSERIALNUMBER.SERIALNUMBER', 'Serial #')}></Column>
              <Column
                dataField="serialNumberNetWeight"
                caption={Localization.formatMessage('WMSERIALNUMBER.NETWEIGHT', 'Net Weight')}
              ></Column>
              <Column
                dataField="serialNumberGrossWeight"
                caption={Localization.formatMessage('WMSERIALNUMBER.GROSSWEIGHT', 'Gross Weight')}
              ></Column>
              <Column dataField="serialNumberSize1" caption={Localization.formatMessage('WMSERIALNUMBER.SIZE_1', 'Size 1')}></Column>
              <Column dataField="serialNumberSize2" caption={Localization.formatMessage('WMSERIALNUMBER.SIZE_2', 'Size 2')}></Column>
              <Column
                dataField="serialNumberReceiptVerified"
                caption={Localization.formatMessage('WMSERIALNUMBER.RECEIPT_VERIFIED', 'Receipt Verified')}
              ></Column>
              <Column
                dataField="serialNumberShipmentVerified"
                caption={Localization.formatMessage('WMSERIALNUMBER.SHIPMENT_VERIFIED', 'Shipment Verified')}
              ></Column>
              <Column dataField="serialNumberRefrence" caption={Localization.formatMessage('WMSERIALNUMBER.USERDEFINEDREFERENCE_1', 'Reference')}></Column>
              <Column dataField="inTransactionNumber" caption='Transaction In' visible={false}></Column>
              <Column dataField="outTransactionNumber" caption='Transaction Out' visible={false}></Column>
              <Toolbar>
                <Item location="after">
                  <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                </Item>
                <Item name="exportButton"  />
                <Item name="columnChooserButton"/> 
              </Toolbar>
            </DataGrid>
          </div>
      </Popup>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(InventorySerialNumberPopup);
